import "./index.css";
import Chart from "./components/Chart";
import { useState, useEffect } from "react";
import { Grid, Typography } from "@mui/material";

const Dashboard = () => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    async function fetchChartsData() {
      // fetchChart data
      setChartData([]);
    }
    fetchChartsData();
  }, []);

  //   const data = [
  //     {
  //       ym: "2018/09",
  //       time: 160,
  //       count: 200,
  //     },
  //     {
  //       ym: "2018/10",
  //       time: 200,
  //       count: 300,
  //     },
  //     {
  //       ym: "2018/11",
  //       time: 120,
  //       count: 150,
  //     },
  //     {
  //       ym: "2018/12",
  //       time: 240,
  //       count: 200,
  //     },
  //   ];
  if (chartData?.length > 0)
    return (
      <Grid container spacing={2} style={{ padding: 10 }}>
        <Grid item xs={12}>
          <Typography align="center" variant="h5" sx={{ color: "#0c8763" }}>
            Στατιστικά Εταιρίας
          </Typography>
        </Grid>
        {chartData.map((chart) => (
          <Grid key={chart?.title} item xs={12} md={6}>
            <Chart
              title={chart?.title}
              defaultChartType={chart?.defaultChartType}
              bindingX={chart?.bindingX}
              bindingSeries={chart?.bindingSeries}
              data={chart?.chartData}
              lastProcessDate={chart?.lastProcessDate}
            />
          </Grid>
        ))}
      </Grid>
    );
};

export default Dashboard;
